import React, { useEffect, useState } from "react";

const QuotationUpdateReasonModal = ({ open, loading = false, onCancel, onSubmit }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setReason("");
      setError("");
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = () => {
    const trimmedReason = reason.trim();
    if (!trimmedReason) {
      setError("Reason is required to update an already submitted quotation.");
      return;
    }
    onSubmit?.(trimmedReason);
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/45 px-4">
      <div className="w-full max-w-lg overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="border-b border-slate-100 px-6 py-2">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-orange-600">Quotation update reason</p>
          <h3 className="mt-2 text-lg font-semibold text-slate-950">Please add a remark for this quotation update</h3>
          <p className="mt-1 text-sm text-slate-500">
            You may mention the reason or changes made. This will be visible to the vendor and recorded in the RFQ audit trail.
          </p>
        </div>
        <div className="px-6 py-2">
          <label className="text-sm font-medium text-slate-700">Reason <span className="text-red-500">*</span></label>
          <textarea
            value={reason}
            onChange={(event) => {
              setReason(event.target.value);
              if (error) setError("");
            }}
            rows={4}
            className="mt-2 w-full resize-none rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-800 outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100"
            placeholder="Add reason for updating this vendor quotation"
            disabled={loading}
          />
          {error ? <p className="mt-2 text-xs font-medium text-red-600">{error}</p> : null}
        </div>
        <div className="flex justify-end gap-2 border-t border-slate-100 bg-slate-50 px-6 py-4">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="rounded-md border border-slate-300 bg-white px-4 py-2 text-xs font-medium text-slate-700 hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className="rounded-md bg-black px-4 py-2 text-xs font-medium text-white hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {loading ? "Submitting..." : "Submit quotation"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuotationUpdateReasonModal;
